// NOTE: is a fix for @https://forum.strapi.io/t/how-to-return-absolute-path/825/4

export const baseStrapiGetAbsoluteFileUrl = (url: string, provider = 'local') => {
  const config = useRuntimeConfig()
  const strapiUrl = config.strapiPublicUrl || config.public.strapiPublicUrl
  strapiUrl.endsWith('/') ? strapiUrl.slice(0, -1) : strapiUrl

  if (!url) { return null } else if (url?.startsWith('http') || url?.startsWith('https')) { return url } else if (provider !== 'local') { return url } else { return `${strapiUrl}${url}` }
}

// Solution would be to use a lifecycle hook to modify the url before it is stored in the db.
// strapi.db.lifecycles.subscribe({
//   models: ["plugin::upload.file"],
//   beforeCreate(event) {
//     if (event.params.data.url) {
//       const imagePath = new URL(event.params.data.url).pathname
//       event.params.data.url = `${strapiPublicUrl}${imagePath}`
//     }
//   },
// })
